jQuery(document).ready(function($){

    // Open external links and PDFs in a new tab
    $('a').not('a[href="#"]').each(function () {
        var isExternal = new RegExp('/' + window.location.host + '/').test(this.href) === false;
        var isPDF = this.href.match(/\.pdf$/i);
        if (isExternal || isPDF) {
            $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
        }
    });

    //Navbar menu toggles
    $('.hamburger, .body-overlay').on('click', function () {
        $('body').toggleClass('menu-open');
    });

    //Add class .scrolled to body when page has been scrolled by the height of navbar
    var scrollTop = 0;
    var navbarHeight = $('.navbar').outerHeight();
    $(window).scroll(function () {
        scrollTop = $(window).scrollTop();
        if (scrollTop >= navbarHeight) {
            $('body').addClass('scrolled');
        } else if (scrollTop < navbarHeight) {
            $('body').removeClass('scrolled');
        }
    });

    // Makes sibling buttons same width as widest
    function adjustButtonWidths(container) {
      var maxWidth = 0;
      container.find('.btn:not(.btn-underline)').each(function() {
        var currentWidth = $(this).outerWidth();
        if (currentWidth > maxWidth) {
          maxWidth = currentWidth;
        }
      });
      container.find('.btn:not(.btn-underline)').css('min-width', maxWidth + 'px');
    }
    // Adjust button widths for both buttons within modals and buttons outside modals
    $('.btns-equal-width').each(function() {
      adjustButtonWidths($(this));
    });
    // Adjust button widths when modal is fully shown
    $('.modal').on('shown.bs.modal', function() {
      adjustButtonWidths($(this));
    });  

});